import { render, staticRenderFns } from "./Stage2.vue?vue&type=template&id=6b8cad5f&"
import script from "./Stage2.vue?vue&type=script&lang=js&"
export * from "./Stage2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports